import React from 'react';

export const DataContext = React.createContext({});

const contextValue = {
  endpointUrl: '/',
  league: window.pageData?.data?.league,
  currentSeason: window.pageData?.data?.season,
};

function DataContextProvider({ children }) {
  return (
    <DataContext.Provider value={contextValue}>{children}</DataContext.Provider>
  );
}

export default DataContextProvider;
